var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 25,
    cy: 25,
    r: 22.5,
    fill: "url(#paint0_linear_210_3741)",
    stroke: "url(#paint1_linear_210_3741)",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.875,
    cy: 25.25,
    r: 19.625,
    fill: "url(#paint2_linear_210_3741)",
    stroke: "url(#paint3_linear_210_3741)",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_3741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2795 30.5931C20.2088 31.5229 21.3529 32.2093 22.6107 32.5916C23.8684 32.974 25.201 33.0405 26.4906 32.7853C27.7802 32.5301 28.987 31.961 30.0043 31.1284C31.0216 30.2959 31.818 29.2254 32.3232 28.0118C32.8284 26.7981 33.0267 25.4787 32.9006 24.1702C32.7745 22.8616 32.3279 21.6044 31.6003 20.5095C30.8727 19.4146 29.8865 18.516 28.7289 17.8929C27.5714 17.2699 26.2781 16.9418 24.9635 16.9375H24.8994C23.3205 16.945 21.7792 17.4195 20.4696 18.3013C19.1599 19.1831 18.1404 20.4327 17.5395 21.8928C16.9386 23.3528 16.7832 24.9581 17.0928 26.5063C17.4025 28.0545 18.1633 29.4765 19.2795 30.5931ZM18.1583 23.586C18.4302 22.2484 19.0902 21.0207 20.056 20.0562C21.0217 19.0917 22.2503 18.4333 23.5882 18.1632C24.0323 18.0735 24.4844 18.0297 24.9374 18.0325C25.8445 18.0329 26.7427 18.2112 27.5811 18.5575C28.8408 19.0815 29.9171 19.9669 30.6742 21.1019C31.4313 22.237 31.8353 23.5708 31.8352 24.9351C31.8353 26.1853 31.496 27.4121 30.8534 28.4846C30.2109 29.557 29.2892 30.4349 28.1868 31.0245C27.0844 31.6141 25.8425 31.8934 24.5938 31.8325C23.3451 31.7716 22.1364 31.3728 21.0965 30.6786C19.961 29.9188 19.076 28.8396 18.5531 27.5774C18.0302 26.3151 17.8928 24.9262 18.1583 23.586Z",
    fill: "#FAFAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6636 21.0539C24.0485 21.2848 24.4861 21.4065 24.9317 21.4065C25.3772 21.4065 25.8148 21.2848 26.1997 21.0539C26.3551 20.9682 26.4864 20.8428 26.5809 20.6898C26.6754 20.5367 26.73 20.3612 26.7393 20.1801C26.7285 19.9997 26.6733 19.8251 26.5789 19.6727C26.4845 19.5203 26.3541 19.395 26.1997 19.3087C25.8148 19.0777 25.3772 18.9561 24.9317 18.9561C24.4861 18.9561 24.0485 19.0777 23.6636 19.3087C23.5102 19.3949 23.381 19.5204 23.2885 19.6731C23.196 19.8257 23.1434 20.0004 23.1357 20.1801C23.1456 20.3595 23.1992 20.5336 23.2914 20.6862C23.3836 20.8389 23.5116 20.9653 23.6636 21.0539Z",
    fill: "#FAFAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 24.3031C23.8482 24.5865 24.39 24.7311 24.9399 24.72C25.4939 24.7331 26.0399 24.5859 26.5113 24.2961C26.7025 24.1906 26.8635 24.0384 26.9791 23.8538C27.0947 23.6692 27.161 23.4583 27.1717 23.2411L26.9586 21.2686L26.9446 21.1265L26.7713 21.3198C26.5298 21.5553 26.2422 21.7389 25.9263 21.8592C25.6104 21.9793 25.2731 22.0336 24.9352 22.0185C24.5975 22.0288 24.2612 21.9708 23.9468 21.8479C23.6323 21.725 23.3463 21.5398 23.1061 21.3035L22.9375 21.1172L22.7033 23.2528C22.7154 23.4708 22.7838 23.6819 22.902 23.8659C23.0201 24.0499 23.184 24.2005 23.3778 24.3031Z",
    fill: "#FAFAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0818 29.7822C24.9242 28.918 23.5722 28.3764 22.1553 28.2091C21.4912 28.1494 20.8225 28.1838 20.1674 28.3114H20.1087L20.1415 28.3528C20.7661 29.2509 21.6092 29.961 22.5848 30.4105C23.9775 31.0392 25.5501 31.0872 26.976 30.5444L27.0276 30.5225L26.9877 30.4836C26.6981 30.2331 26.3956 29.999 26.0818 29.7822Z",
    fill: "#FAFAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.707 28.2075C27.0541 28.2688 26.4117 28.419 25.7964 28.6543L25.7303 28.6813L25.7964 28.7157C26.2523 28.9604 26.6842 29.2507 27.0859 29.5824C27.3165 29.7678 27.5365 29.967 27.7448 30.179L27.7637 30.1987L27.7849 30.1864C28.1695 29.9739 28.5266 29.7115 28.8477 29.4056C29.1837 29.0955 29.4833 28.7453 29.7404 28.3621L29.7663 28.3228H29.7144C29.0537 28.1872 28.378 28.1483 27.707 28.2075Z",
    fill: "#FAFAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0072 27.7492C28.1796 27.7492 30.7754 26.0385 30.7754 23.9371C30.7754 22.5076 29.589 21.2091 27.6339 20.5587L27.5864 20.5444V20.6015C27.5823 20.6188 27.5823 20.6367 27.5864 20.654C27.5828 20.6712 27.5828 20.6891 27.5864 20.7064L27.8664 23.4368C27.8536 23.7199 27.7702 23.9952 27.6239 24.2375C27.4775 24.4797 27.2729 24.6812 27.0288 24.8234C26.4256 25.2114 25.7211 25.4104 25.0049 25.3952C24.2924 25.4064 23.592 25.2103 22.988 24.8306C22.4447 24.4684 22.1434 23.9752 22.1434 23.4558L22.4257 20.6945V20.6421C22.4257 20.623 22.4257 20.6015 22.4257 20.5896V20.542L22.3782 20.5563C20.4492 21.2115 19.2439 22.5076 19.2439 23.9371C19.2367 26.0385 21.823 27.7492 25.0072 27.7492Z",
    fill: "#FAFAF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_3741",
    x1: 45.13,
    y1: 5.785,
    x2: 10.1313,
    y2: 47.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163662,
    stopColor: "#459188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459188",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_210_3741",
    x1: 25,
    y1: 2.125,
    x2: 5.09875,
    y2: 44.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459188",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459188",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_210_3741",
    x1: 42.475,
    y1: 8.45,
    x2: 11.875,
    y2: 45.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91BCB9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930146,
    stopColor: "#459188"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_210_3741",
    x1: 39.875,
    y1: 8.65,
    x2: 7.475,
    y2: 42.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459188",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_3741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16.9375 16.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenBadge);
export default __webpack_public_path__ + "static/media/TokenBadge.c5cbd25621c7d2f979fc419ab5cdfb9d.svg";
export { ForwardRef as ReactComponent };